import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import cloneDeepWith from 'lodash/fp/cloneDeepWith';
import { config } from '../config';

const isLocalhost = () => window.location.hostname === 'localhost';

const tokenStringReplacer = (val: string) => {
    if (val && typeof val.replace === 'function') {
        let sanitizedVal = val.replace(/access_token=[^&]*/, 'access_token=REDACTED');
        sanitizedVal = sanitizedVal.replace(/id_token=[^&]*/, 'id_token=REDACTED');
        return sanitizedVal;
    }
};

const env = config.id === 'env.production' ? 'prod' : 'staging';
const serviceName = `route-widget${env === 'staging' ? '-dev' : '-prod'}`;

const setupErrorLogger = () => {
    const clientToken = config.datadog.datadog_logs_client_token;
    datadogLogs.init({
        clientToken,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: serviceName,
        env,
        beforeSend: obj => {
            // Filter out UIKIT version check errors
            if (obj.message?.includes('versionsList.json') || obj.error?.message?.includes('versionsList.json')) {
                return false;
            }
            return cloneDeepWith(tokenStringReplacer, obj);
        },
    });
    datadogLogs.setGlobalContextProperty('account_id', config.aws_client_id);
    datadogLogs.setGlobalContextProperty('team', 'MAN Smart Route Planning');
    datadogLogs.setGlobalContextProperty('team_identifier', 'man-team-smart-route-planning');
    datadogLogs.setGlobalContext({ level: 'info' });
};

const setupRealUserMonitoring = () => {
    const applicationId = config.datadog.datadog_rum_app_id;
    const clientToken = config.datadog.datadog_rum_client_token;
    const version = config.build_version;
    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.eu',
        service: serviceName,
        version,
        sampleRate: 100,
        premiumSampleRate: 100,
        trackInteractions: true,
        env,
        defaultPrivacyLevel: 'mask',
    });

    datadogRum.startSessionReplayRecording();
};

if (!isLocalhost()) {
    setupErrorLogger();
    // Disable datadog rum: We do not use the service and it is very costly to maintain for all users
    // setupRealUserMonitoring();
}
